import { defineComponent, ref } from 'vue'
export default defineComponent({
    props: {
        icon: { type: Object, default: undefined },
    },
    data() {
        return {
            icons: this.icon || ''
        }
    },
    render() {
        return this.icons;
    },
})
